import React, { useCallback, useContext, useState } from 'react';
import { isFeatureEnabled, Feature } from '../../config/FeaturesConfig';
import DataSource from '../../api';
import { StateContext } from '../../GlobalStateStore';
import { useParams } from 'react-router';
import { getCscEntityPrefix } from '../../config/Config';
import Expander from '@amzn/meridian/expander';
import ContactListeningContent from './ContactListeningContent';
import Column from '@amzn/meridian/column';
import { useIntl } from 'react-intl';
import moment from 'moment';
import { CLClickstream } from './utils/ContactListeningHelpers';
import useCustomTracking from '../../Util/useCustomTracking';

export interface ContactListeningHeaderProps {
  contactID: string;
  contactListening: any;
  contactListeningState: any;
  setContactListening: any;
  setContactListeningState: any;
  contactStartDate?: string;
  contactEndDate?: string;
  setContactListeningParams: any;
  CLClickstream: CLClickstream;
}

const ContactListeningHeader: React.FC<ContactListeningHeaderProps> = ({
  contactID,
  contactListening,
  contactListeningState,
  setContactListening,
  setContactListeningState,
  contactStartDate,
  contactEndDate,
  setContactListeningParams,
  CLClickstream,
}: ContactListeningHeaderProps): React.ReactElement => {
  const intl = useIntl();
  const [open, setOpen] = useState(false);
  const [queryParams, setQueryParams] = useState();
  const contactListeningWithChatEnabled = isFeatureEnabled(
    Feature.CONTACT_LISTENING_WITH_CHAT
  );
  const defaultContactStartDate = moment()
    .subtract(1, 'years')
    .format('YYYY-MM-DD');
  const defaultContactEndDate = moment().format('YYYY-MM-DD');

  const globalState = useContext(StateContext);
  const { inspireOptions } = globalState.state;
  const { userID, requesterUsername, requesterOwner, isTm } =
    inspireOptions.data;
  const routeParams = useParams();
  const routeUserID = routeParams?.userId;
  const subject = `${requesterUsername}@${requesterOwner.toLowerCase()}`;
  const agentUserId =
    getCscEntityPrefix() + ':' + (routeUserID ? routeUserID : userID);

  const [OpenCLModalTrackingTag, openCLModalClick] = useCustomTracking(
    `contact-listening-${contactID}`,
    CLClickstream.slotID,
    {
      'data-csa-c-type': 'button',
      'data-csa-c-tag1': CLClickstream.tag1,
      'data-csa-c-tag2': CLClickstream.tag2,
      'data-csa-c-tag3': CLClickstream.tag3,
      'data-csa-c-tag4': CLClickstream.tag4,
      'data-csa-c-tag5': CLClickstream.tag5,
      'data-csa-c-contactid': contactID,
      'data-csa-c-is-tm': isTm,
      'data-csa-c-username': requesterUsername,
    }
  );
  const onClickContactId = useCallback((val: any, setOpen: any) => {
    openCLModalClick();
    setOpen(val);
    if (val) {
      const apiNaws = DataSource.getDataFeed('NAWS');
      const queryVariables = apiNaws.prepareContactListeningDataQuery(
        agentUserId,
        contactID,
        contactStartDate ? contactStartDate : defaultContactStartDate,
        contactEndDate ? contactEndDate : defaultContactEndDate,
        subject
      );
      setContactListeningParams(queryVariables);
      setQueryParams(queryVariables);
      if (contactListeningWithChatEnabled) {
        apiNaws.getContactListeningDataWithChat(
          queryVariables,
          setContactListening,
          setContactListeningState
        );
      } else {
        apiNaws.getContactListeningData(
          queryVariables,
          setContactListening,
          setContactListeningState
        );
      }
    }
  }, []);
  return (
    <div min-width='700px' max-width='700px'>
      <Expander
        title={`${intl.formatMessage({
          id: 'cs_perfportal_contact_listening_contact',
          defaultMessage: 'Contact',
        })} - ${contactID}`}
        type='inline'
        open={open}
        onChange={val => {
          onClickContactId(val, setOpen);
        }}
      >
        <Column alignmentHorizontal='center'>
          <ContactListeningContent
            contactListeningData={contactListening}
            loadingState={contactListeningState}
            contactListeningParams={queryParams}
            CLClickstream={{
              ...CLClickstream,
              contactID: contactID,
            }}
          />
        </Column>
      </Expander>
      <OpenCLModalTrackingTag />
    </div>
  );
};
export default ContactListeningHeader;
